import { apiFetch } from "./client";
import type { components } from "./schema";

export type MapPoint = components["schemas"]["MapPoint"];

export async function mapPoints(): Promise<MapPoint[]> {
  return (await apiFetch<components["schemas"]["CompanyMap"]>("/companies/map")).items;
}
